<template>
  <div>
    <b-table id="table-controle" hover :items="items" :fields="fields">
      <template v-slot:cell(dateCreation)="row">
        <span> {{ row.item.dateCreation }}</span>
      </template>
      <template v-slot:cell(motifControle)="row">
        <span> {{ row.item.motifControle }}</span>
      </template>
      <template v-slot:cell(libelleCampagne)="row">
        <span> {{ row.item.libelleCampagne }}</span>
      </template>
      <template v-slot:cell(createur)="row">
        <span> {{ row.item.createur }}</span>
      </template>
      <template v-slot:cell(typeControle)="row">
        <span> {{ row.item.typeControle }}</span>
      </template>
      <template v-slot:cell(statut)="row">
        <span v-if="row.item.new_added">
          <b-form-select v-model="row.item.statut" :options="statusOptions" :disabled="!row.item.can_edit"
                         :class="{hasError: errors.statut !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.statut }}</span>
        </span>
        <span v-else>
          <b-form-select v-if="row.item.can_edit" v-model="row.item.selectedStatut" :options="statusOptions"
                         :disabled="!row.item.can_edit" :class="{hasError: errors.statut !== ''}">
          </b-form-select>
          <span v-else>{{ row.item.statut }}</span>
        </span>
      </template>
      <template v-slot:cell(dateMajStatut)="row">
        <span> {{ row.item.dateMajStatut }}</span>
      </template>
      <template v-slot:cell(resultat)="row">
        <span v-if="row.item.new_added">
          <b-form-select v-model="row.item.resultat" :options="resultatsOptions" :disabled="!row.item.can_edit"
                         :class="{hasError: errors.resultat !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.resultat }}</span>
        </span>
        <span v-else>
          <b-form-select v-model="row.item.selectedResultat" :options="resultatsOptions"
                         :disabled="!row.item.can_edit || row.item.selectedStatut === statusControleAbandonneId"
                         :class="{hasError: errors.resultat !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.resultat }}</span>
        </span>
      </template>
      <template v-slot:cell(motifAnomalie)="row">
        <span v-if="row.item.new_added">
          <b-form-select v-model="row.item.motifAnomalie" :options="motifsAnomalieOptions"
                         :disabled="!row.item.can_edit" :class="{hasError: errors.motifAnomalie !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.motifAnomalie }}</span>
        </span>
        <span v-else>
          <b-form-select v-model="row.item.selectedMotifAnomalie" :options="motifsAnomalieOptions"
                         :disabled="!row.item.can_edit || row.item.selectedStatut ===  statusControleAbandonneId || row.item.selectedResultat === resultatOKId"
                         :class="{hasError: errors.motifAnomalie !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.motifAnomalie }}</span>
        </span>
      </template>
      <template v-slot:cell(gestionnaire)="row">
        <span> {{ row.item.gestionnaire }}</span>
      </template>
      <template v-slot:cell(action)="row">
        <i title="Voir pièces jointes" v-bind:class="[row.item.piecesJointes.length > 0 ? 'green-color' : '']" class="icon fa fa-eye fa-1-5x mr-2 clickable" v-if="canShow(row.item)" @click="showPj(row.item)"></i>
        <i class="icon fa fa-pencil fa-1-5x mr-2 text-primary clickable"
           v-if="isEditable(row.item.gestionnaireAffecteId, row.item.selectedStatut) && canEdit(row.item)"
           @click="row.item.can_edit = !row.item.can_edit" title="Modifier"></i>
        <i class="icon fa fa-upload fa-1-5x mr-2 text-primary clickable" v-if="canUpload(row.item)"
           @click="uploadDocument(row.item)" title="Insérer pièces jointes"></i>
        <i class="icon fa fa-save fa-1-5x text-primary mr-2 clickable" v-if="row.item.can_edit" @click="save(row.item)"
           title="Enregistrer"></i>
      </template>
    </b-table>
    <b-row class="mt-4">
      <b-col sm="12">
        <b-form-group
          label="Commentaires"
          label-for="commentaire"
          :label-cols="2"
          :horizontal="true">
          <b-form-textarea
            id="commentaire"
            type="text"
            rows="3"
            max-rows="9"
            :disabled="isDisabled('commentaire')"
            v-model="myData.commentaire">
          </b-form-textarea>
        </b-form-group>
        <div v-if="displayAllComments" v-for="(element,key) in allComments" :key="key" class="mb-2">
          <div class="comment-bloc mb-1 p-2">
            <span style="color: #1c00ff">
              <i>Le {{formatDate(element.created_at)}}, par {{ element.gestionnaire.nom}} {{ element.gestionnaire.prenom}}</i>
            </span>
            <br>
            <span>{{element.commentaire}}</span>
          </div>
        </div>
        <div v-if="allComments.length > 0 && !displayAllComments" class="comment-bloc mb-1 p-2">
            <span style="color: #1c00ff">
              <i>Le {{formatDate(lastComment.created_at)}}, par {{ lastComment.gestionnaire.nom}} {{ lastComment.gestionnaire.prenom}}</i>
            </span>
          <br>
          <span>{{lastComment.commentaire}}</span>
        </div>
        <div class="pull-right">
          <b-button @click="displayAllComments = !displayAllComments" class="mb-3">
            <span v-if="!displayAllComments">Voir les anciens commentaires</span>
            <span v-if="displayAllComments">Cacher les anciens commentaires</span>
          </b-button>
          <b-button @click="enregistrerCommentaire" class="mb-3 ml-2" variant="primary"><i class="fa fa-save"></i> Enregistrer le commentaire</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col sm="12">
        <controle-pj :dossier="dossier" :controle="this.selectedControle"></controle-pj>
      </b-col>
    </b-row>
    <b-modal centered no-close-on-esc no-close-on-backdrop hide-header-close title="Ajout de pièces jointes"
             id="modal-chargement-pj" ref="modal-chargement-pj">
      <b-form>
        <div>
          <b-form-group
            label='Fichier(s)'
            label-for='nom_fichier'>
            <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                         multiple
                         class="file-input"
                         drop-placeholder="Déposer le(s) fichier(s) ici..."
                         browse-text="Parcourir"
                         :state="errors.attachments !== '' ? false : null"
                         :file-name-formatter="formatNames"
                         @change="addFile($event)"
                         @input="clearErrors()">
            </b-form-file>
            <span class="field-error">{{ errors.attachments }}</span>
          </b-form-group>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="saveFile()">
            Enregistrer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="closeModal('modal-chargement-pj')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import {getUser} from '@/utils/auth'
  import {
    isEmpty,
    getIconSrc as getIconSrcMain,
    getReadableFileSize as getReadableFileSizeMain
  } from "@/utils/fileHelper"
  import ControlePj from "@/components/Dossier/DetailsDossier/ControlePj"

  export default {
    components: {ControlePj},
    name: "Controle",
    props: [
      'dossier',
      'traitements',
    ],
    data() {
      return {
        dateCreation: '',
        motifControle: '',
        selectedMotifControle: '',
        libelleCampagne: '',
        createur: '',
        typeControle: '',
        selectedTypeControle: '',
        statut: '',
        selectedStatut: '',
        dateMajStatut: '',
        resultat: '',
        selectedResultat: '',
        motifAnomalie: '',
        gestionnaire: '',
        selectedMotifAnomalie: '',
        newElementAdded: false,
        fields: [
          {
            key: 'dateCreation',
            label: 'Date de\ncréation',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'motifControle',
            label: 'Motif du controle',
            thClass: 'pre-formatted align-middle',
            sortable: true
          },
          {
            key: 'libelleCampagne',
            label: 'Libellé de la campagne',
            thClass: 'pre-formatted align-middle',
            tdClass: 'tooltip-cell'
          },
          {
            key: 'createur',
            label: 'Créateur',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'typeControle',
            label: 'Type de contrôle',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'statut',
            label: 'Statut',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'dateMajStatut',
            label: 'Date MAJ Statut',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'resultat',
            label: 'Résultat',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'motifAnomalie',
            label: 'Motif principal anomalie',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'gestionnaire',
            label: 'Affecté à',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'Action',
            label: 'Action',
            thClass: 'pre-formatted align-middle'
          }
        ],
        items: [],
        motifsControleOptions: [],
        typesControleOptions: [],
        statusOptions: [],
        resultatsOptions: [],
        motifsAnomalieOptions: [],
        currentTreatment: {},
        myData: {
          commentaire: '',
        },
        lastComment: {},
        allComments: [],
        displayAllComments: false,
        errors: {motifControle: '', typeControle: '', statut: '', resultat: '', motifAnomalie: '', attachments: ''},
        canSaveControle: false,
        selectedControle: {},
        typeUpload: '',
        attachments: [],
        statusControleTermineId: null,
        statusControleAbandonneId: null,
        statusControleAControlerId: null,
        resultatOKId: null,
        isEmpty,
      }
    },
    watch: {
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'Controle', value);
        }, 2000),
        deep: true,
      },
      dossier() {
        this.setCommentairesControles();
        this.getControles();
      }
    },
    created() {
      this.$event.on('validateControle', (valid) => {
        this.canSaveControle = valid;
      });
    },
    async mounted() {
      this.getMotifsControle();
      this.getTypesControle();
      this.getStatus();
      this.getResultats();
      this.getMotifsAnomalie();
      this.getControles();
      this.setCommentairesControles();
      this.getCurrentTreatment();
    },
    methods: {
      isTraitement(type) {
        // Passer par une validation par type permet qu'aucun bouton ne s'affiche, plutot que le mauvais bouton, s'il y a un problème sur la récupération du currentTreatment
        return (this.currentTreatment.type === type && this.currentTreatment.categorie === 'Controle');
      },
      setCommentairesControles() {
        this.allComments = this.dossier.commentaires_qualite;
        if (this.allComments.length > 0) {
          this.lastComment = this.allComments[this.allComments.length - 1];
        }
      },
      canAddControle() {
        let can = true;
        for (let status of this.dossier.status) {
          if (parseInt(status.pivot.traitement_id) === parseInt(this.$route.query.traitementId) && this.$parent.$parent.$parent.statusTraiteIds.indexOf(status.id) > -1) {
            can = false;
          }
        }

        return can && this.canInitiateControle();
      },
      canInitiateControle() {
        let user = getUser()

        let treatmentAuthorized = user.profil_active[0].traitements.filter((element) => {
          return (this.currentTreatment.type === 'Principal' && this.currentTreatment.categorie === 'Controle'
          && parseInt(element.id,10) === parseInt(this.$route.query.traitementId, 10))
        });

        return treatmentAuthorized.length > 0;
      },
      addControle(type) {
        if (!this.newElementAdded) {
          this.newElementAdded = true;
          this.items.push({
            dateCreation: new Date().toLocaleDateString('fr-FR'),
            motifControle: '',
            libelleCampagne: '',
            createur: '',
            typeControle: '',
            status: '',
            dateMajStatut: '',
            resultat: '',
            motifAnomalie: '',
            gestionnaire: '',
            can_edit: true,
            new_added: true,
            type: type,
          });
        }
      },
      async save(controle) {
        this.$parent.$parent.$parent.clearErrors();
        this.newElementAdded = false;

        let data = {
          'dossier_id': this.dossier.id,
          'createur_id': getUser().id,
          'motif_controle_id': controle.motifControle,
          'type_controle_id': controle.typeControle,
          'campagne_id': '',
          'libelle_campagne': controle.libelleCampagne,
          'status_id': controle.statut,
          'date_maj': controle.dateMajStatut,
          'resultat_controle_id': controle.resultat,
          'motif_principal_id': controle.motifAnomalie,
          'gestionnaire': controle.gestionnaire,
          'can_edit': false
        };

        let dataToEdit = {
          'motif_controle_id': controle.selectedMotifControle,
          'type_controle_id': controle.selectedTypeControle,
          'status_id': controle.selectedStatut,
          'resultat_controle_id': this.statusControleAbandonneId === controle.selectedStatut ? null : controle.selectedResultat,
          'motif_principal_id': (this.statusControleAbandonneId === controle.selectedStatut) ? null : (controle.selectedResultat === this.resultatOKId) ? null : controle.selectedMotifAnomalie,
          'can_edit': false
        };

        if (controle.id) {
          this.saveEdit(controle, dataToEdit);
        } else {
          this.$event.emit('addControle');
          if (this.canInitiateControle()) {
            if (controle.motifControle) {
              this.$event.emit('addControle');
              await this.saveStore(controle, data);
            } else {
              this.errors.motifControle = 'Vous devez choisir un motif de contrôle.'
            }
          } else {
            this.$swal({
              position: 'top',
              type: 'warning',
              title: 'Attention !!',
              text: 'Vous n\'avez pas les droits nécessaires pour ajouter une ligne de contrôle',
              showConfirmButton: false,
              timer: 5000
            })
          }
        }
      },
      validateDataResultat(data) {
        this.clearErrors()
        let valid = true;
        if (data.status_id === this.statusControleTermineId && data.resultat_controle_id === null) {
          valid = false;
          this.errors.resultat = "Veuillez choisir un résultat.";
        }
        if (data.status_id !== this.statusControleAbandonneId && data.resultat_controle_id !== this.resultatOKId && (isEmpty(data.motif_principal_id) || data.motif_principal_id === null)) {
          valid = false;
          this.errors.motifAnomalie = "Veuillez choisir un motif principal anomalie.";
        }
        return valid
      },
      saveEdit(controle, data) {
        let self = this;
        if (this.validateDataResultat(data)) {
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceQualite/controles/edit/' + controle.id, data)
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              this.manageChange()
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Modification avec succès',
                text: 'La ligne de contrôle a bien été modifiée',
                showConfirmButton: false,
                timer: 3000
              })
            })
            .catch((error) => {
              self.$store.commit('IS_LOADING', false)
              let errorText = 'Une erreur est survenue lors de la modification de la ligne de contrôle. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      async saveStore(controle, data) {
        let self = this;
        this.$parent.$parent.$parent.clearErrors();
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceQualite/controles/store', data)
          .then(async (response) => {
            this.$store.commit('IS_LOADING', false);
            this.manageChange();
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Création avec succès',
              text: 'La ligne de contrôle a bien été ajoutée',
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            let errorText = 'Une erreur est survenue lors de la création de la ligne de contrôle. Si le problème persiste, merci de faire un ticket au support DOSI.'
            if (error.response !== undefined && error.response.status === 409) {
              errorText = error.response.data.message;
            }
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      deleteControle(item) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer cette ligne de contrôle ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .get("/espaceQualite/controles/delete/" + item.id)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange()
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Suppression avec succès',
                  text: 'La ligne de contrôle a bien été supprimée',
                  showConfirmButton: false,
                  timer: 3000
                })
              })
              .catch(function (error) {
                self.$store.commit('IS_LOADING', false)
                self.$swal({
                  position: 'top',
                  type: 'warning',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue lors de la suppression de la ligne de contrôle. Si le problème persiste, merci de faire un ticket au support DOSI.',
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
      },
      isDisabled(field) {
        if (field === 'sousStatut' && (this.isTreatment('qualification_courrier') || this.isTreatment('ij_fichier_prolongation') || this.isTreatment('ij_expertise_presta'))) {
          return true;
        }
      },
      async getControles() {
        let self = this
        this.items = [];
        await this.$axios
          .get("/espaceQualite/controles/dossierId/" + this.dossier.id)
          .then(response => {
            this.items = [];
            this.controles = response.data.controles
            for (let controle of response.data.controles) {
              if (controle.campagne !== null) {
                this.addControleToList(controle)
              }
            }
          })
          .catch((error) => {
            // self.$store.commit('IS_LOADING', false)
            let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      addControleToList(controle) {
        let piecesJointes = _.filter(controle.dossier.pieces_jointes, function(pieceJointe) {
          return pieceJointe.controle_id == controle.id
        })
        this.items.push({
          id: controle.id,
          dateCreation: new Date(controle.date_creation).toLocaleDateString("fr-FR"),
          motifControle: controle.motifs_controles.libelle,
          selectedMotifControle: controle.motif_controle_id,
          libelleCampagne: controle.campagne ? controle.campagne.libelle : '',
          gestionnaire: controle.gestionnaire_qualite ? controle.gestionnaire_qualite.nom + ' ' + controle.gestionnaire_qualite.prenom : '',
          campagneId: controle.campagne_id,
          createur: controle.createur.prenom.substring(0, 1).toUpperCase() + '. ' + controle.createur.nom,
          typeControle: controle.types_controles.libelle,
          selectedTypeControle: controle.type_controle_id,
          statut: controle.status !== null ? controle.status.libelle_bo : '',
          selectedStatut: controle.status_id,
          dateMajStatut: controle.date_maj ? new Date(controle.date_maj).toLocaleDateString("fr-FR") : '',
          resultat: controle.resultat_controle_dossiers !== null ? controle.resultat_controle_dossiers.libelle : '',
          selectedResultat: controle.resultat_controle_id,
          motifAnomalie: controle.motif_principal_ano !== null ? controle.motif_principal_ano.libelle : '',
          selectedMotifAnomalie: controle.motif_principal_id,
          can_edit: false,
          new_added: false,
          gestionnaireAffecteId: controle.gestionnaire_qualite_id,
          piecesJointes: piecesJointes,
        });
      },
      getMotifsControle() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/getMotifsControle')
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            const motifsControle = response.data.motifs_controle;
            for (let i = 0; i < motifsControle.length; i++) {
              this.motifsControleOptions.push({
                text: motifsControle[i].libelle,
                value: motifsControle[i].id
              });
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getTypesControle() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/getTypesControle')
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            const typesControle = response.data.types_controle;
            for (let i = 0; i < typesControle.length; i++) {
              this.typesControleOptions.push({
                text: typesControle[i].libelle,
                value: typesControle[i].id
              });
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getStatus() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/allControleStatuts')
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            const statusControle = response.data.status_controle;
            const statusControleTermine = _.find(statusControle, (status) => {
              return status.libelle_technique === 'controle_termine'
            });
            this.statusControleTermineId = !isEmpty(statusControleTermine) ? statusControleTermine.id : null;

            const statusControleAbandonne = _.find(statusControle, (status) => {
              return status.libelle_technique === 'controle_abandonne'
            });
            this.statusControleAbandonneId = !isEmpty(statusControleAbandonne) ? statusControleAbandonne.id : null;

            const statusControleAControler = _.find(statusControle, (status) => {
              return status.libelle_technique === 'controle_a_controler'
            });
            this.statusControleAControlerId = !isEmpty(statusControleAControler) ? statusControleAControler.id : null;

            for (let i = 0; i < statusControle.length; i++) {
              if (statusControle[i].libelle_technique === 'controle_termine' || statusControle[i].libelle_technique === 'controle_abandonne') {
                this.statusOptions.push({
                  text: statusControle[i].libelle_bo,
                  value: statusControle[i].id
                });
              }
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getResultats() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/getResultatsControle')
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            const resultatsControle = response.data.resultats_controle;
            const resultatOK = resultatsControle.find(element => element.libelle_technique === 'ok');
            this.resultatOKId = !isEmpty(resultatOK) ? resultatOK.id : null;

            for (let i = 0; i < resultatsControle.length; i++) {
              if (resultatsControle[i].traitement_id === null) {
                if (resultatsControle[i].libelle_technique !== 'ko' && resultatsControle[i].libelle_technique !== 'non_conforme') {
                  this.resultatsOptions.push({
                    text: resultatsControle[i].libelle,
                    value: resultatsControle[i].id
                  });
                }
              }
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getMotifsAnomalie() {
        if (!isEmpty(this.dossier.type)) {
          let self = this;
          // this.$store.commit('IS_LOADING', true);
          let dossierType = this.dossier.type.groupe
          this.$axios
            .get('/espaceQualite/getMotifPrincipalAno/' + dossierType)
            .then(response => {
              // this.$store.commit('IS_LOADING', false);
              const motifsPrincipalAno = response.data.motifs_principal_ano;
              for (let i = 0; i < motifsPrincipalAno.length; i++) {
                this.motifsAnomalieOptions.push({
                  text: motifsPrincipalAno[i].libelle,
                  value: motifsPrincipalAno[i].id
                });
              }
            })
            .catch(() => {
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Un problème est survenu, merci de contacter l\'administrateur',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      canDelete(item) {
        return this.isResponsable()
      },
      canEdit(item) {
        return this.canInitiateControle();
      },
      isResponsable() {
        let isResponsable = false
        let user = getUser()

        for (let equipe of user.equipes) {
          if (equipe.pivot.role === 'responsable') {
            isResponsable = true
          }
        }

        return isResponsable
      },
      closeModal(refModal) {
        this.$refs[refModal].hide()
        this.clearErrors()
      },
      uploadDocument(item) {
        this.selectedControle = item;
        this.$refs['modal-chargement-pj'].show()
      },
      addFile(event) {
        this.attachments = event.target.files
      },
      saveFile() {
        let self = this
        let controleId = this.selectedControle.id
        if (this.validateSaveFile()) {
          let formData = new FormData();
          for (var i = 0; i < this.attachments.length; i++) {
            let file = this.attachments[i];
            formData.append('files[' + i + ']', file)
          }
          formData.append('traitement_id', this.$route.query.traitementId)

          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post('/espaceQualite/controles/addDocuments/' + controleId, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((response) => {
              this.$store.commit('IS_LOADING', false)
              this.manageChange()
              this.closeModal('modal-chargement-pj')

              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Document(s) ajouté(s) avec succès',
                text: 'Document(s) ajouté(s) avec succès',
                showConfirmButton: false,
                timer: 3000
              })
            })
            .catch((error) => {
              let errorText = 'Une erreur est survenue lors de l\'ajout de pièces jointes. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              })
            }).finally(() => this.$store.commit('IS_LOADING', false));
        }
      },
      validateSaveFile() {
        let valid = true

        if (this.attachments.length === 0) {
          valid = false
          this.errors.attachments = 'Vous devez choisir un fichier'
        }

        return valid
      },
      manageChange() {
        this.getControles()
        this.$event.emit('refreshDossier')
      },
      clearErrors() {
        this.errors.dateCreation = ''
        this.errors.motifControle = ''
        this.errors.libelleCampagne = ''
        this.errors.createur = ''
        this.errors.typeControle = ''
        this.errors.statut = ''
        this.errors.dateMajStatut = ''
        this.errors.resultat = ''
        this.errors.motifAnomalie = ''
        this.errors.attachments = ''
      },
      canShow(item) {
        return this.canInitiateControle();
      },
      canUpload(item) {
        return this.canInitiateControle();
      },
      formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} fichiers selectionnés`
        }
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
      getReadableFileSize(size) {
        return getReadableFileSizeMain(size)
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique);
        return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId, 10) === treatment.id
      },
      getCurrentTreatment() {
        this.currentTreatment = this.traitements.reduce((res, treatment) => {
          return treatment.id === parseInt(this.$route.query.traitementId, 10) ? treatment : res;
        }, {});
      },
      getIconSrc(type, dossier) {
        let images = require.context('@/assets/images/', false, /\.png$/)
        let icon = ''

        if (type === 'corner') {
          icon = 'corner-top-right-10.png'
        }

        return images('./' + icon)
      },
      timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      showPj(item) {
        this.selectedControle = item;
      },
      isEditable(gestionnaireQualiteId, statutControleId) {
        return getUser().id === gestionnaireQualiteId && !isEmpty(gestionnaireQualiteId) && this.dossier.motif_reouverture_id === null;
      },
      enregistrerCommentaire() {
        let self = this;
        let postData = {
          dossierId: this.dossier.id,
          commentaireQualite: this.myData.commentaire
        };
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/dossier/commentaire/qualite', postData)
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.$event.emit('refreshDossier');
            this.myData.commentaire = '';
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Succès',
              text: 'Commentaire enregistré avec succès',
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            let errorText = 'Une erreur est survenue lors de l\'enregistrement du commentaire. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          }).finally(() => this.$store.commit('IS_LOADING', false));
      },
    }
  };
</script>
<style scoped>
  table {
    width: 100%;
    overflow-x: auto;
  }

</style>
<style type="text/css">
  .ck.ck-editor, .ck.ck-reset {
    width: 100%;
  }

  .no-padding {
    padding: 0;
  }

  .no-decoration {
    list-style: none;
  }

  .icon-size-16 {
    width: 16px;
  }

  .fa-1-5x {
    font-size: 1.5em;
  }

  #table-controle {
    font-size: 0.8rem;
  }

  tr td.tooltip-cell {
    position: relative;
  }

  tr td.tooltip-cell img {
    position: absolute;
    top: 0;
    right: 0;
  }

  .show-pj {
    color: aqua;
  }

  .hide-pj {
    color: gray;
  }

  .green-color {
    color:#80104B;
  }
</style>
